import { createEntityFilterStore } from "./createEntityFilterStore";
import type { PromoterFilters } from "@/domain/types";

const initialFilters: PromoterFilters = {
	search: "",
	status: "",
	sector: "",
	sort: { key: undefined, direction: null },
};

export const usePromoterFiltersStore = createEntityFilterStore<PromoterFilters>(
	"PromoterFiltersStore",
	initialFilters,
);
